module.exports = __webpack_public_path__ + "img/cruise-placeholder.8012265.png";